<div
	*ngIf="renderListOperations"
	class="listOperationWrapper d-flex flex-wrap flex-column flex-md-row mb-3 ps-3 ps-md-0"
	[ngClass]="{
		'd-none': hideListOperations,
		'd-flex': !hideListOperations
	}"
>

	<!-- SEARCH	-->
	<div
		*ngIf="renderSearch"
		class="operationWrapper col-12 pe-3 ps-0 col-md-auto"
		[ngClass]="{ 'd-none': hideSearch	}"
	>
		<ng-container *ngTemplateOutlet="searchTpl"></ng-container>
	</div>

	<!-- SORT	-->
	<div
		*ngIf="renderSort"
		class="operationWrapper col-12 pe-3 ps-0 col-md-auto"
		[ngClass]="{ 'd-none': hideSort }"
	>
		<ng-container *ngTemplateOutlet="sortTpl"></ng-container>
	</div>

	<!-- FILTER	-->
	<div
		*ngIf="renderFilter"
		class="operationWrapper col-12 pe-3 ps-0 col-md-auto"
		[ngClass]="{ 'd-none': hideFilter	}"
	>
		<ng-container *ngTemplateOutlet="filterTpl"></ng-container>
	</div>

	<!-- Pagination	-->
	<div
		*ngIf="renderPagination"
		class="operationWrapper col-auto px-0 ms-auto"
		[ngClass]="{ 'd-none': hidePagination }"
	>
		<ng-container *ngTemplateOutlet="paginateTpl"></ng-container>
	</div>
</div>

<!-- ######################### TEMPLATES ######################### -->
<!-- searchTpl -->
<ng-template #searchTpl>
	<app-search
		#searchCmp
		*ngIf="searchData"
		[activeListOperationChange]="activeListOperation"
		[defaultSearchData]="searchData"
		(activeListOperationEmitter)="setActiveListOperation( $event )"
		(operationChangedEmitter)="onOperationSearchEmitter( $event, true )"
		(operationInitializedEmitter)="onOperationSearchEmitter( $event )"
	></app-search>
</ng-template>

<!-- sortTpl -->
<ng-template #sortTpl>
	<app-sort
		#sortCmp
		*ngIf="sortData"
		[activeListOperationChange]="activeListOperation"
		[defaultSortData]="sortData"
		(activeListOperationEmitter)="setActiveListOperation( $event )"
		(operationChangedEmitter)="onOperationSortEmitter( $event, true )"
		(operationInitializedEmitter)="onOperationSortEmitter( $event )"
	></app-sort>
</ng-template>

<!-- filterTpl -->
<ng-template #filterTpl>
	<app-filter
		#filterCmp
		*ngIf="filterData"
		[activeListOperationChange]="activeListOperation"
		[defaultFilterData]="filterData"
		[listOperationIdentifier]="listOperationsConfigData.id"
		(activeListOperationEmitter)="setActiveListOperation( $event )"
		(operationChangedEmitter)="onOperationFilterEmitter( $event, true )"
		(operationInitializedEmitter)="onOperationFilterEmitter( $event )"
	></app-filter>
</ng-template>

<!-- paginateTpl -->
<ng-template #paginateTpl>
	<app-pagination
		#paginationCmp
		*ngIf="pagingData"
		[activeListOperationChange]="activeListOperation"
		[defaultPagingData]="pagingData"
		[pagingInput]="paging"
		(activeListOperationEmitter)="setActiveListOperation( $event )"
		(operationChangedEmitter)="onOperationPaginationEmitter($event, true)"
		(operationInitializedEmitter)="onOperationPaginationEmitter($event)"
	></app-pagination>
</ng-template>
